export const facetsListData = [
  {
    linkList: [
      {
        linkLabel: 'Lawton',
        linkURL: '/en-us/destinations/united-states/oklahoma/lawton.mi',
        openInNewTab: false,
      },
      {
        linkLabel: 'Oklahoma City',
        linkURL: '/en-us/destinations/united-states/oklahoma/oklahoma-city.mi',
        openInNewTab: false,
      },
      {
        linkLabel: 'Tulsa',
        linkURL: '/en-us/destinations/united-states/oklahoma/tulsa.mi',
        openInNewTab: false,
      },
    ],
    heading: 'Cities in Oklahoma',
  },
  {
    filter: 'amenities',
    linkList: [
      {
        linkLabel: 'Free Breakfast',
        filter: 'breakfast',
        linkURL: '/en-us/destinations/united-states/oklahoma/free-breakfast-hotels.mi',
        openInNewTab: false,
      },
      {
        linkLabel: 'Fitness Center',
        filter: 'fitness-center',
        linkURL: '/en-us/destinations/united-states/oklahoma/fitness-center-hotels.mi',
        openInNewTab: false,
      },
    ],
    heading: 'Hotel By Amenities',
  },
];
export const DestinationAccordionContainerEnhancedModelMock = {
  rootHeaderTag: 'h2',
  componentId: 'gzqodewy937i8tiu',
  rootHeaderFontStyle: 't-body-m',
  dataLayer: {
    'destinationsAccordion-bc3267dc1f': {
      '@type': 'mi-aem-leisure-spa/components/destinationsAccordion',
      'repo:modifyDate': '2025-11-13T15:26:18Z',
    },
  },
  showExpandCollapseAllControl: false,
  expandAllLabel: '',
  styleclass: 'alternate',
  title: '<p>Explore More in Oklahoma</p>',
  trackingProperties: {
    additionalTrackingVariables: '',
    enableScrollingBehavior: false,
    trackingDescription: '',
    impressionTrack: false,
    description: '',
    trackingContentPosition: '',
    atCCeVar48: '',
    rightArrowDesc: '',
    cardLocation: '',
    leftArrowDesc: '',
    clickTrack: false,
    location: '',
    merchandisingCategory: 'nonCobrand',
    impressionCount: false,
    trackingTag: '',
    trackingOfferType: '',
  },
  isAuthor: true,
  path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/destinationsaccordio_1252862878',
  cqType: 'mi-aem-leisure-spa/components/destinationsAccordion',
  collapseAllLabel: '',
  headerAlignment: 'left',
  activateDrawerBehavior: false,
  id: 'destinationsAccordion-bc3267dc1f',
  facetsData: facetsListData,
  wcmMode: 'edit',
};
export const DestinationAccordionContainerEnhancedPropsMock = {
  rootHeaderTag: 'h2',
  componentId: 'cfirbyev4babb71m',
  rootHeaderFontStyle: 't-body-m',
  dataLayer: {
    'destinationsAccordion-c042da448f': {
      '@type': 'mi-aem-leisure-spa/components/destinationsAccordion',
      'repo:modifyDate': '2025-10-28T06:37:41Z',
    },
  },
  model: DestinationAccordionContainerEnhancedModelMock,
  title: '<p>Explore More in Oklahoma</p>\r\n',
  trackingProperties: {
    additionalTrackingVariables: '',
    enableScrollingBehavior: false,
    trackingDescription: '',
    impressionTrack: false,
    description: '',
    trackingContentPosition: '',
    atCCeVar48: '',
    rightArrowDesc: '',
    cardLocation: '',
    leftArrowDesc: '',
    clickTrack: false,
    location: '',
    merchandisingCategory: 'nonCobrand',
    impressionCount: false,
    trackingTag: '',
    trackingOfferType: '',
  },
  isAuthor: false,
  path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/destinationsaccordio',
  ':type': 'mi-aem-leisure-spa/components/destinationsAccordion',
  headerAlignment: 'left',
  id: 'destinationsAccordion-c042da448f',
  sectionList: facetsListData,
  wcmMode: 'disabled',
  collapseAllLabel: '',
  expandAllLabel: '',
  activateDrawerBehavior: false,
  showExpandCollapseAllControl: false
};

export const DestinationAccordionContainerEnhancedMock = {
  ...DestinationAccordionContainerEnhancedPropsMock,
  isAuthorMode: true,
  allowedComponents: [
    {
      path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainer',
      title: 'Accordion Container',
    },
    {
      path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/richtext',
      title: 'Rich Text',
    },
    {
      path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainerenhanced',
      title: 'Accordion Container-Enhanced',
    },
    {
      path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/text',
      title: 'Text',
    },
    {
      path: '/content/mi-aem-leisure-spa/na/en-us/destinations/destination-page/jcr:content/root/responsivegrid/mi-aem-leisure-spa/components/destinationsAccordion',
      title: 'Destinations Accordion',
    },
  ],
};

export default DestinationAccordionContainerEnhancedMock;
